<app-page-header
  title="Kundenaccounts verwalten"
  subtitle="Suche und verwalte alle Kundenaccounts"
  icon="people"
  variant="gradient"
  [showBackButton]="true">
  
</app-page-header>

<!-- Search Field (optional, if you have filtering) -->
<!--
<div class="nlc-container nlc-slide-up">
  <div class="nlc-search-card nlc-card">
    <mat-form-field appearance="outline" class="nlc-search-field">
      <mat-label>Suche nach Kunde</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Kundennr, Name, E-Mail..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
-->

<div class="nlc-container">
  <div class="nlc-manage-customers-table-card nlc-card">
    <table class="nlc-manage-customers-table">
      <thead>
        <tr class="nlc-table-header-row">
          <th class="global-table-header-cell">Kundennr.</th>
          <th class="global-table-header-cell">Name</th>
          <th class="global-table-header-cell">E-Mail</th>
          <th class="global-table-header-cell">Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of customers$ | async" class="nlc-table-row">
          <td class="global-table-cell">{{ customer?.reflexCustomerNo }}</td>
          <td class="global-table-cell">{{ customer?.userDetails?.firstName }} {{ customer?.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ customer?.userDetails?.email }}</td>
          <td>
            <div class="customer-actions-btn-row">
              <button *ngIf="!customer.isActive" mat-flat-button color="primary" class="nlc-button nlc-button-primary nlc-details-btn" (click)="approveCustomer(customer)" matTooltip="Kunde freischalten">
                <span>Freischalten</span>
                <mat-icon>check_circle</mat-icon>
              </button>
              <button *ngIf="!customer.isActive" mat-flat-button color="warn" class="nlc-button nlc-button-primary nlc-details-btn" (click)="rejectCustomer(customer)" matTooltip="Kunde ablehnen">
                <span>Ablehnen</span>
                <mat-icon>cancel</mat-icon>
              </button>
              <button mat-flat-button color="accent" class="nlc-button nlc-button-primary nlc-details-btn" (click)="toggleActivation(customer)">
                <span>{{ customer.isActive ? 'Deaktivieren' : 'Aktivieren' }}</span>
                <mat-icon>{{ customer.isActive ? 'block' : 'check_circle' }}</mat-icon>
              </button>
              <button mat-flat-button color="primary" class="nlc-button nlc-button-primary nlc-details-btn" (click)="goToCustomer(customer)">
                <span>Details</span>
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="(customers$ | async)?.length === 0" class="empty-state">
      Keine Kunden gefunden.
    </div>
  </div>
</div>
